
export default function itemPayload(properties, values) {
  const item = {}
  Object.keys(properties).map((property) => {
    if (values[property] === undefined) {
      return
    }
    item[property] = values[property]
  })
  return item
}
